import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44614268"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "a-button__loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["a-button", [
      _ctx.buttonRound,
      _ctx.buttonFill,
      _ctx.buttonBold,
      _ctx.buttonSize,
      _ctx.buttonDisabled,
      _ctx.buttonProcessing,
      _ctx.buttonPreventDefault
    ]]),
    disabled: _ctx.preventDefault || _ctx.processing
  }, [
    (_ctx.processing)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
  ], 10, _hoisted_1))
}